
const ShareIcon = (): JSX.Element => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" 
            width="24" height="24" viewBox="0 0 24 24" fill="" stroke="" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="18" cy="5" r="3" fill=""></circle>
            <circle cx="6" cy="12" r="3" fill=""></circle>
            <circle cx="18" cy="19" r="3" fill=""></circle>
            <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" fill=""></line>
            <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" fill=""></line>
        </svg>       
    )
  }
  
  export default ShareIcon;
  